<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Account</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Security</a></li>
                    </ul>

                    <h3>Password Management</h3>

                    <div class="field">
                        <label for="password1">New Password</label>
                        <InputText id="password1" type="password" v-model.trim="updatePasswordInfo.password1"/>
                    </div>

                    <div class="field">
                        <label for="password2">Verify Password</label>
                        <InputText id="password2" type="password" v-model.trim="updatePasswordInfo.password2"/>
                    </div>

                    <Button label="Save" class="mr-2 mb-2" @click="updatePassword"></Button>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            submitted: false,
            updatePasswordInfo: {}
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;
        },
        async updatePassword() {
            this.submitted = true;

            if (this.updatePasswordInfo.password1.trim()) {
                console.log("[Profile][processUpdatePassword] password1 = ", this.updatePasswordInfo.password1);
                console.log("[Profile][processUpdatePassword] password2 = ", this.updatePasswordInfo.password2);
                console.log("[Profile][processUpdatePassword] Password1 length = ", this.updatePasswordInfo.password1.length);

                if (this.updatePasswordInfo.password1.length < 8) {
                    console.log("[Profile][processUpdatePassword] Got into password length check. Password1 = ", this.updatePasswordInfo.password1);
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Unsuccessful',
                        detail: 'Password needs to be at least 8 characters',
                        life: 3000
                    });
                } else if (this.updatePasswordInfo.password1 !== this.updatePasswordInfo.password2) {
                    console.log("[Profile][processUpdatePassword] Got into password NOT equals password2 check. Password1 = ", this.updatePasswordInfo.password1);
                    this.$toast.add({severity: 'error', summary: 'Unsuccessful', detail: 'Passwords do not match', life: 3000});
                } else if (this.updatePasswordInfo.password1 === this.updatePasswordInfo.password2) {
                    console.log("[Profile][processUpdatePassword] Got into password equals password2 check. Password1 = ", this.updatePasswordInfo.password1);
                    this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Passwords do match', life: 3000});

                    try {
                        var newUserDto = {
                            id: this.userStore.user.id,
                            password: this.updatePasswordInfo.password1,
                            username: this.profile.username,
                            email: this.profile.email,
                            mobile: this.profile.mobile,
                            firstName: this.profile.firstName,
                            lastName: this.profile.lastName,
                            roles: this.profile.roles,
                            companyId: this.profile.companyId
                        };
                        const response = await UserService.updateUser(this.userStore.user.id, newUserDto);
                        console.log('[PhoneCalls][updatePhoneCall] Response = ', response);

                        const userData = await UserService.getUser(this.userStore.user.id);
                        this.profile = userData.data;

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Updated user password',
                            life: 3000
                        });
                    } catch (error) {
                        console.error('[PhoneCalls][updatePhoneCall] Error:', error);

                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to update user password. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.updatePasswordInfo = {};
            this.submitted = false;
        }

    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
